import { render, staticRenderFns } from "./FeedAmount.vue?vue&type=template&id=22a2a588&scoped=true&"
import script from "./FeedAmount.vue?vue&type=script&lang=js&"
export * from "./FeedAmount.vue?vue&type=script&lang=js&"
import style0 from "./FeedAmount.vue?vue&type=style&index=0&id=22a2a588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2a588",
  null
  
)

export default component.exports